<button
  *ngIf="!disabled || !hideBtnOnDisabled"
  (click)="newAction()"
  [disabled]="disabled"
  class="add-edit-button"
  [class.disabled]="disabled"
>
    <img *ngIf="actionType === 'adding'" src="assets/icons/add_square_button.svg">
    <img *ngIf="actionType === 'editing'" src="assets/icons/edit_square_button.svg">
    <img *ngIf="actionType === 'cancel'" src="assets/icons/delete_square_button.svg">
</button>
